import styled from 'styled-components';

export const SpinnerWrapper = styled.div<{ isBackgroundDisabled: boolean; isLocal: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: ${({ isLocal }) => (isLocal ? 'absolute' : 'fixed')};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    background: ${({ isBackgroundDisabled }) =>
      isBackgroundDisabled ? 'none' : 'rgba(255, 255, 255, 0.8)'};
  }
`;

export const Loader = styled.div`
  &,
  &:after {
    border-radius: 50%;
    width: 10em;
    height: 10em;
  }
  & {
    z-index: 1;
    margin: 60px auto;
    font-size: 10px;
    position: relative;
    text-indent: -9999em;
    border-top: ${({ theme }) => `1.1em solid ${theme.customColors.primary}`};
    border-right: ${({ theme }) => `1.1em solid ${theme.customColors.primary}`};
    border-bottom: ${({ theme }) => `1.1em solid ${theme.customColors.primary}`};
    border-left: 1.1em solid #ffffff;
    transform: translateZ(0);
    animation: load8 1.1s infinite linear;
  }
  @keyframes load8 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const StyledDelayMessage = styled.span`
  position: absolute;
  z-index: 100;
  top: calc(50% + 60px);
  font-size: 22px;
  color: ${({ theme }) => theme.primaryColour};
  opacity: 0;
  animation: messageTransition 0.3s forwards;
  animation-delay: 3s;
  @keyframes messageTransition {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
